export function getToFixed(value: number | null, fixedCount: number = 1) {
	if (!value) return 0;
	if (fixedCount === 1) {
		return Math.round(value * 1e1) / 1e1;
	}
	return 0;
}
